// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getDatabase } from 'firebase/database'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBenUl1F9ulYajU7MQEYUv27dK4_9rCoh8",
  authDomain: "technopaws-86c5f.firebaseapp.com",
  projectId: "technopaws-86c5f",
  storageBucket: "technopaws-86c5f.appspot.com",
  messagingSenderId: "602328985222",
  appId: "1:602328985222:web:c518e459424435293beb07",
  measurementId: "G-2H05LFGJHM",
  databaseURL: "https://technopaws-86c5f-default-rtdb.firebaseio.com"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app)

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app)

// Initialize Realtime Database and get a reference to the service
const rtdb = getDatabase(app)

export { auth, db, rtdb }
